import { DataBean } from "../../../DataBean";



export class ClinicalDocumentEvent extends DataBean {


    public async getClinicalDocumentEventCatalog(idClinicalDocument:any,issueDate:any,state:any,regexStr:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getClinicalDocumentEventCatalog_Number_java.util.Date_Number_String_Number_Number", [idClinicalDocument,issueDate,state,regexStr,page,recordsPerPage]);
    }


}